import { formatDurationMs } from "../format"
import { TextCell } from "./text-cell"

type Props = {
  value: number | null | undefined
  align?: "left" | "right" | "center"
}

export function DurationCell({ value, align = "right" }: Props) {
  return <TextCell value={formatDurationMs(value)} align={align} mono />
}
